import React, { useEffect, useState } from 'react'
import {useForm} from "react-hook-form"
import { apiConnector } from '../services/apiconnector';
import { contactusEndpoint } from '../services/apis';
import CountryCode from '../data/countrycode.json'

const ContactUsForm = () => {

    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        formState: {errors, isSubmitSuccessful}
    } = useForm();

    const submitContactForm = async(data) => {
        try{
            setLoading(true);
            // const response = await apiConnector("POST", contactusEndpoint.CONTACT_US_API, data);
            const response = {status:"OK"};
            console.log("Logging response", response);
            setLoading(false);
        }
        catch(error) {
            console.log("Error:" , error.message);
            setLoading(false);
        }
    }

    useEffect( () => {
        if(isSubmitSuccessful) {
            reset({
                email:"",
                firstname:"",
                lastname:"",
                message:"",
                phoneNo:"",
            })
        }
    },[reset, isSubmitSuccessful] );


  return (
    <form onSubmit={handleSubmit(submitContactForm)}>

    <div className='flex flex-col gap-4  rounded-lg  lg:w-[50vw] min-h-[90vh]  mx-auto my-12 py-5 px-6 bg-richblack-800'>
            <div className='flex gap-5 py-5 '>
                {/* firstName */}
                <div className='flex flex-col  justify-center '>
                    <label htmlFor='firstname' className='text-white py-2'>First Name</label>
                    <input  
                        type='text'
                        name='firstname'
                        id='firstname'
                        placeholder='Enter first name'
                        className='text-black px-2 py-1 rounded-md mt-2'
                        {...register("firstname", {required:true})}
                    />
                    {
                        errors.firstname && (
                            <span className='text-richblack-300 text-sm p-1'>
                                <span className='text-yellow-5'>*</span>  Please enter Your name
                            </span>
                        )
                    }
                </div>

                {/* lastName */}
                <div className='flex flex-col'>
                    <label htmlFor='lastname' className='text-white py-2 '>Last Name</label>
                    <input  
                        type='text'
                        name='lastname'
                        id='lastname'
                        className='text-black px-2 py-1 rounded-md mt-2'
                        placeholder='Enter Last name'
                        {...register("lastname")}
                    />
                    
                </div>

            </div>


            {/* email */}
            <div className='flex flex-col'>
                <label htmlFor='email' className='text-white py-2'>Email Address</label>
                <input 
                    type='email'
                    name='email'
                    id='email'
                    className='text-black px-2 py-1 rounded-md mt-2  '
                    placeholder='Enter email Address'
                    {...register("email", {required:true})}
                />
                {
                    errors.email && (
                        <span className='text-richblack-300 text-sm p-1'>
                                <span className='text-yellow-5'>*</span>  Please enter your email
                            </span>
                    )
                }
            </div>

            {/* phoneNo */}
            <div className='flex flex-col'>

                <label htmlFor='phonenumber' className='text-white py-2'>Phone Number</label>

                <div className='flex flex-row gap-1'>
                    {/* dropdown */}
                   
                        <select
                            name='dropdown'
                            id="dropdown"
                            className='text-black px-1 py-1  bg-yellow-50 w-[80px] rounded-md mt-2'
                            {...register("countrycode", {required:true})}
                        >
                            {
                                CountryCode.map( (element , index) => {
                                    return (
                                        <option key={index} value={element.code}>
                                            {element.code} -{element.country}
                                        </option>
                                    )
                                } )
                            }
                        </select>
                        
                        <input
                            type='number'
                            name='phonenumber'
                            id='phonenumber'
                            placeholder='12345 67890'
                            className='text-black px-2 py-1 rounded-md mt-2 w-[calc(100%-80px)]'
                            {...register("phoneNo",  
                            {
                                required:{value:true, message:"Please enter Phone Number"},
                                maxLength: {value:10, message:"Invalid Phone Number"},
                                minLength:{value:8, message:"Invalid Phone Number"} })}
                        />
                  
                </div>
                {
                    errors.phoneNo && (
                        <span className='text-richblack-300 text-sm p-1'>
                        <span className='text-yellow-5'>*</span>  {errors.phoneNo.message}                    </span>
                    )
                }

            </div>

            {/* message */}
            <div className='flex flex-col'>
                <label htmlFor='message' className='text-white py-2'>Message</label>
                <textarea 
                    name='message'
                    id='message'
                    cols="30"
                    className='text-black px-2 py-1 rounded-md mt-2'
                    rows="7"
                    placeholder='Enter Your message here'
                    {...register("message", {required:true})}
                />
                {
                    errors.message && (
                        <span>
                            PLease enter your message.
                        </span>
                    )
                }
            </div>
                
            <button type='submit'
            className='rounded-md bg-yellow-50  lg:w-[40%] py-4 mx-auto text-center px-6 text-[19px] font-bold text-black'>
                    Send Message
            </button>
    </div>

    </form>
  )
}

export default ContactUsForm
